/**
 *  TanStack Router configuration for the LOA Frontend.
 * @module app
 */

import { createBrowserHistory, createRouter } from "@tanstack/react-router";

import { routeTree } from "./routeTree.gen";

const browserHistory = createBrowserHistory();

/**
 * Configured TanStack Router instance for the application.
 *
 * @type {Router}
 * @module app
 * @category Routing
 *
 * @remarks
 * The router is configured with:
 * - **File-based routing**: Routes are auto-generated from the `src/routes/` directory
 * - **Intent-based preloading**: Routes are preloaded when the user shows intent to navigate
 * - **Code splitting**: Routes are automatically code-split for optimal loading
 *
 * The route tree is generated by the TanStack Router Vite plugin and should not
 * be modified manually. To add new routes, create files in the `src/routes/` directory.
 *
 * @example
 * ```typescript
 * // Route file naming conventions:
 * // src/routes/index.tsx        -> /
 * // src/routes/about.tsx        -> /about
 * // src/routes/users/$id.tsx    -> /users/:id
 * // src/routes/users/index.tsx  -> /users
 * ```
 *
 * @see {@link https://tanstack.com/router/latest/docs/framework/react/overview TanStack Router Docs}
 * @see {@link routeTree} for the auto-generated route configuration
 */
export const router = createRouter({
  routeTree,
  history: browserHistory,
  defaultPreload: "intent",
});
